import $ from 'jquery';
export class EmailTemplates {
    static openedPreviewInputsStatus = {};
    static init() {
        this.initTemplatePreviewActions();
        this.initTemplateEditActions();
        this.initSaveButtonVisibility();
    }
    static initTemplateEditActions() {
        $('.js__email-template-input').on('change', e => {
            const inputId = $(e.currentTarget).attr('id');
            this.openedPreviewInputsStatus = { ...this.openedPreviewInputsStatus, ...{ [String(inputId)]: false } };
            this.initSaveButtonVisibility();
        });
        this.initiateDefaultValues('.js__email-template-input', 'initial-template');
        this.initiateDefaultValues('.js__email-subject-field', 'initial-subject');
    }
    static initiateDefaultValues(selector, dataAttribute) {
        const $templateInput = $(selector);
        const initValue = $templateInput.data(dataAttribute);
        if (initValue != null) {
            $templateInput.val(initValue);
        }
    }
    static initTemplatePreviewActions() {
        $('.js__show-email-preview').on('click', e => {
            e.preventDefault();
            const $previewButton = $(e.currentTarget);
            const $parent = $previewButton.closest('.js__email-wrapper');
            const $source = $parent.find('.js__email-template-input');
            const $preview = $parent.find('.js__email-preview');
            const $iframe = $preview.find('iframe');
            const $editButton = $parent.find('.js__show-email-edit');
            const url = $preview.data('url');
            const $subject = $parent.parent().find('.js__email-subject-field');
            $.ajax({
                url,
                data: {
                    email_code: $source.data('email-code'),
                    template: $source.val(),
                    subject: $subject.val(),
                },
                method: 'POST',
                cache: false,
                beforeSend: () => {
                    $previewButton.addClass('loading');
                },
            })
                .done(data => {
                $iframe.attr('src', data);
                $preview.toggleClass('hidden');
                $source.parent().toggleClass('hidden');
                $previewButton.toggleClass('hidden');
                $editButton.toggleClass('hidden');
                this.openedPreviewInputsStatus = {
                    ...this.openedPreviewInputsStatus,
                    ...{ [String($source.attr('id'))]: true },
                };
                this.initSaveButtonVisibility();
            })
                .always(() => {
                $previewButton.removeClass('loading');
            });
        });
        $('.js__show-email-edit').on('click', e => {
            e.preventDefault();
            const $parent = $(e.currentTarget).closest('.js__email-wrapper');
            const $source = $parent.find('.js__email-template-input');
            const $preview = $parent.find('.js__email-preview');
            const $editButton = $(e.currentTarget);
            const $previewButton = $parent.find('.js__show-email-preview');
            $preview.toggleClass('hidden');
            $source.parent().toggleClass('hidden');
            $previewButton.toggleClass('hidden');
            $editButton.toggleClass('hidden');
        });
    }
    static initSaveButtonVisibility() {
        const $saveButton = $('.js__email-template-input').first().closest('form').find('[type=submit]');
        const isSaveDisabled = Object.values(this.openedPreviewInputsStatus).some(v => v === false);
        $saveButton.prop('disabled', isSaveDisabled);
        $('.js__check-preview-message').toggle(isSaveDisabled);
    }
}
